import React from 'react';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'radial-gradient(ellipse at center, #3d0c2e 0%, #080808 70%)',
    textAlign: 'center',
    padding: '2rem',
  },
  logo: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
    fontWeight: 300,
    letterSpacing: '0.15em',
    color: '#c9a84c',
    textTransform: 'uppercase',
    marginBottom: '1.5rem',
  },
  heading: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(2.5rem, 7vw, 5rem)',
    fontWeight: 300,
    lineHeight: 1.1,
    color: '#f5f0ea',
    marginBottom: '1.5rem',
  },
  sub: {
    fontSize: '1rem',
    fontWeight: 300,
    color: '#f5f0ea',
    opacity: 0.65,
    maxWidth: '480px',
    lineHeight: 1.7,
  },
};

export default function App() {
  return (
    <div style={styles.container}>
      <div style={styles.logo}>Liberated After Dark</div>
      <h1 style={styles.heading}>
        Coming Soon
      </h1>
      <p style={styles.sub}>
        The 30-day program is on its way. Something powerful is being built.
      </p>
    </div>
  );
}
